import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { useVocabUnitData } from "../../database";
import { STUDY_OPTIONS_PATH } from "../../constants";
import Flashcard from "./Flashcard";
import "./FlashcardStudyPage.css";

function FlashcardStudyPage() {
  const location = useLocation();
  const unit = location.state.unit;
  const { data: vocabData, loading, error } = useVocabUnitData(unit.unit, unit.textbook);

  const [preExistingFlashcards, setPreExistingFlashcards] = useState([]);
  const [mainPageUserAddedFlashcards, setMainPageUserAddedFlashcards] =
    useState(() => {
      const localData = localStorage.getItem("mainPageUserAddedFlashcards");
      return localData ? JSON.parse(localData) : [];
    });
  const [
    favoritesPageUserAddedFlashcards,
    setFavoritesPageUserAddedFlashcards,
  ] = useState(() => {
    const localData = localStorage.getItem("favoritesPageUserAddedFlashcards");
    return localData ? JSON.parse(localData) : [];
  });

  const [flashcards, setFlashcards] = useState([]);
  const [favoriteFlashcards, setFavoriteFlashcards] = useState([]);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [koreanText, setKoreanText] = useState("");
  const [englishText, setEnglishText] = useState("");
  const [imageURL, setImageURL] = useState("");
  const [selectedFlashcardIndex, setSelectedFlashcardIndex] = useState(null);

  const [showKorean, setShowKorean] = useState(false);


  const [currentPage, setCurrentPage] = useState("main");

  useEffect(() => {
    if (!loading && vocabData.length > 0) {
      setPreExistingFlashcards((prevState) => {
        if (JSON.stringify(prevState) !== JSON.stringify(vocabData)) {
          return vocabData;
        }
        return prevState;
      });
    }
  }, [vocabData, loading]);

  useEffect(() => {
    localStorage.setItem(
      "mainPageUserAddedFlashcards",
      JSON.stringify(mainPageUserAddedFlashcards)
    );
    localStorage.setItem(
      "favoritesPageUserAddedFlashcards",
      JSON.stringify(favoritesPageUserAddedFlashcards)
    );
  }, [mainPageUserAddedFlashcards, favoritesPageUserAddedFlashcards]);

  const userAddedFlashcards =
    currentPage === "main"
      ? mainPageUserAddedFlashcards
      : favoritesPageUserAddedFlashcards;

  const handleAddFlashcard = (index) => {
    setSelectedFlashcardIndex(index);
    setIsModalVisible(true);
  };

  const handleKoreanTextChange = (e) => {
    setKoreanText(e.target.value);
  };

  const handleImageURLChange = (e) => {
    setImageURL(e.target.value);
  };

  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (event) => {
        setImageURL(event.target.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleDelete = (index) => {
    if (index < preExistingFlashcards.length) {
      return;
    }

    const userAddedIndex = index - preExistingFlashcards.length;
    const updatedUserAddedFlashcards =
      currentPage === "main"
        ? [...mainPageUserAddedFlashcards]
        : [...favoritesPageUserAddedFlashcards];
    updatedUserAddedFlashcards.splice(userAddedIndex, 1);

    if (currentPage === "main") {
      setMainPageUserAddedFlashcards(updatedUserAddedFlashcards);
    } else {
      setFavoritesPageUserAddedFlashcards(updatedUserAddedFlashcards);
    }
  };

  const handleToggleFavoritesFilter = () => {
    setCurrentPage("favorites");
  };

  const handleToggleFavorite = (index) => {
    const updatedFlashcards = [...flashcards];
    const toggledFlashcard = { ...updatedFlashcards[index] };

    toggledFlashcard.isStarred = !toggledFlashcard.isStarred;

    updatedFlashcards[index] = toggledFlashcard;
    setFlashcards(updatedFlashcards);

    if (toggledFlashcard.isStarred) {
      setFavoriteFlashcards((prevFavorites) => [
        ...prevFavorites,
        toggledFlashcard,
      ]);
    } else {
      setFavoriteFlashcards((prevFavorites) =>
        prevFavorites.filter(
          (favFlashcard) => favFlashcard !== toggledFlashcard
        )
      );
    }
  };

  const filteredFlashcards = [
    ...preExistingFlashcards,
    ...userAddedFlashcards,
  ].filter(
    (flashcard) => flashcard.unit === `unit${unit.unit}` || !flashcard.unit
  );

  const handleSaveFlashcard = () => {
    if (selectedFlashcardIndex !== null) {
      const updatedUserAddedFlashcards =
        currentPage === "main"
          ? [...mainPageUserAddedFlashcards]
          : [...favoritesPageUserAddedFlashcards];
      updatedUserAddedFlashcards[selectedFlashcardIndex] = {
        ...updatedUserAddedFlashcards[selectedFlashcardIndex],
        korean: koreanText,
        english: englishText,
        image: imageURL,
      };

      if (currentPage === "main") {
        setMainPageUserAddedFlashcards(updatedUserAddedFlashcards);
      } else {
        setFavoritesPageUserAddedFlashcards(updatedUserAddedFlashcards);
      }
    } else {
      const newFlashcard = {
        korean: koreanText,
        english: englishText,
        image: imageURL,
        isUserAdded: true,
        isStarred: false,
        unit: `unit${unit.unit}`,
      };

      if (currentPage === "main") {
        setMainPageUserAddedFlashcards([
          ...mainPageUserAddedFlashcards,
          newFlashcard,
        ]);
      } else {
        setFavoritesPageUserAddedFlashcards([
          ...favoritesPageUserAddedFlashcards,
          newFlashcard,
        ]);
      }
    }
    setIsModalVisible(false);
    setKoreanText("");
    setEnglishText("");
    setImageURL("");
    setSelectedFlashcardIndex(null);
  };

  const handleCloseModal = () => {
    setIsModalVisible(false);
    setKoreanText("");
    setEnglishText("");
    setImageURL("");
    setSelectedFlashcardIndex(null);
  };

  return (
    <div id="flashcard-container">
      {/* {filteredFlashcards.map((flashcard, index) => (
        <Flashcard
          key={index}
          flashcard={flashcard}
          imageURL={flashcard.image}
          onDeleteFlashcard={() => handleDelete(index)}
          onToggleFavorite={() => handleToggleFavorite(index)}
          isStarred={flashcard.isStarred}
        />
      ))} */}
      {filteredFlashcards.map((flashcard, index) => (
        <Flashcard
          key={index}
          flashcard={{
            korean: flashcard.korean || "Unknown",
            english: flashcard.english || (flashcard.englishLiterals ? flashcard.englishLiterals[0] : "No translation available"),
            imgPath: flashcard.imgPath || "",
            imgWidth: flashcard.imgWidth || 180,
            imgHeight: flashcard.imgHeight || 200,
            audioPath: flashcard.audioPath || null,
            isUserAdded: flashcard.isUserAdded || false,
            isStarred: flashcard.isStarred || false,
          }}
          imageURL={flashcard.image || flashcard.imgPath}
          onDeleteFlashcard={() => handleDelete(index)}
          showKorean={showKorean}
        />
      ))}
      <div className="button-container">
        <div className="flashcard-back-button">
          <Link to={STUDY_OPTIONS_PATH} state={unit}>
            <button>Back</button>
          </Link>
        </div>
        <div className="add-flashcard-button">
          <button onClick={() => handleAddFlashcard(null)}>
            Add Flashcard
          </button>
        </div>
        <div className="toggle-language-button">
          <button onClick={() => setShowKorean((prev) => !prev)}>
            {showKorean ? "Show English" : "Show Korean"}
          </button>
        </div>
      </div>

      {isModalVisible && (
        <div className="modal-popup">
          <div className="flashcard-modal">
            <h2>
              {selectedFlashcardIndex !== null ? "Edit" : "Add"} Flashcard
            </h2>
            <div className="modal-content">
              <label>
                Korean Text:
                <input
                  type="text"
                  value={koreanText}
                  onChange={handleKoreanTextChange}
                  required
                />
              </label>
              <label>
                English Meaning:
                <input
                  type="text"
                  value={englishText}
                  onChange={(e) => setEnglishText(e.target.value)}
                />
              </label>
              <div className="image-input-container">
                <label>
                  Image URL:
                  <input
                    type="text"
                    value={imageURL}
                    onChange={handleImageURLChange}
                    required
                  />
                </label>
                <label>
                  or Upload Image:
                  <input
                    type="file"
                    accept="image/*"
                    onChange={handleImageUpload}
                  />
                </label>
              </div>
              {imageURL && (
                <div className="image-preview">
                  <img src={imageURL} alt="Image Preview" />
                </div>
              )}
            </div>
            <div className="modal-buttons">
              <button onClick={handleSaveFlashcard}>Save</button>
              <button onClick={handleCloseModal}>Cancel</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default FlashcardStudyPage;
